import React, { ReactElement } from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import styles from './Link.module.scss';
import useGameSlug from '../../hooks/useGameSlug';
import useGame from '@resources/js/contexts/useGame';
import { GameSlug } from '../../config';

type LinkProps = {
  href: string;
  children: ReactElement | string;
};

export default function Link(props: LinkProps): JSX.Element | null {
  const router = useRouter();
  const gameSlug = useGameSlug();
  const game = useGame();
  if (!gameSlug || !game) {
    return null;
  }

  if (props.href.startsWith('/')) {
    const href = getFullyQualifiedArticlePath(props.href, gameSlug);

    const isActive =
      (href.endsWith('/') ? href.slice(undefined, -1) : href) === router.asPath;

    return (
      <NextLink
        {...props}
        href={href}
        className={isActive ? styles.isActive : undefined}
      >
        {props.children}
      </NextLink>
    );
  }

  if (props.href.startsWith('../')) {
    return <a {...props} href={game.baseUrl + props.href.substring(2)} />;
  }

  return <a {...props} target={'_blank'} rel={'noopener noreferrer'} />;
}

export function getFullyQualifiedArticlePath(
  path: string,
  gameSlug: GameSlug
): string {
  return `/${gameSlug}/articles${path}`;
}
